export default "__VITE_ASSET__b88f7c93__"